<template>
    <div class="o-section-header">
        <h2 class="o-section-header__title" v-text="title"/>
        <p v-if="subTitle" class="o-section-header__text" v-text="subTitle"/>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },
        subTitle: {
            type: String,
            required: false
        }
    }
}
</script>
